import { Route } from "@angular/router";

import { NotArchivedPlan, numericIdGuard } from "../../../core/guards";
import { viewDataEntryPagesGuards } from "../_guards";

export const KPI_ACTUALS_ROUTES: Route[] = [
  {
    path: "kpi",
    canActivate: [...viewDataEntryPagesGuards],
    children: [
      {
        path: "",
        data: {
          title: "data_entry.kpi_actuals",
          breadcrumb: "data_entry.kpi_actuals",
        },
        loadComponent: () => import("./kpi-actuals-list/kpi-actuals-list").then((e) => e.KpiActualsListComponent),
      },
      {
        path: "edit/:id",
        canActivate: [numericIdGuard("/console/data-entry/kpi"), NotArchivedPlan()],
        data: {
          title: "data_entry.edit_title",
          breadcrumb: "data_entry.edit_title",
        },
        loadComponent: () => import("./kpi-actuals-editor/kpi-actuals-editor").then((e) => e.KpiActualsEditorComponent),
      },
    ],
  },
];
